import React from 'react';
import {
	Popover,
	Button,
	Text,
	PopoverContent,
	useDisclosure,
	Box,
	PopoverHeader,
	Flex,
	FormLabel,
	PopoverCloseButton,
	PopoverTrigger,
	Portal,
	IconButton,
} from '@chakra-ui/react';
import queries from '../../utils/query';
import { useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { cssVariables } from '../../redux/cssVariablesSlice';
import CSSEditorInputs from '../canvas/CssEditor/CSSEditorInputs';
import { UilPalette } from '@iconscout/react-unicons';

const y300 = { bg: 'yellow.300', borderColor: 'yellow.300' };
const y400 = { bg: 'yellow.400', borderColor: 'yellow.400' };
const boxW = '430px';
const boxPopoverWrapper = {
	transition: 'none',
	borderRadius: '6px',
	boxShadow: 'xl',
	zIndex: 9999,
	bg: 'white',
	w: boxW,
	top: 0,
};

const PopoverEditCSSVariables = ({ viewId }) => {
	const [updateViewCssVariables, __] = useMutation(queries.UPDATE_VIEW_CSS_VARIABLES);
	const cssVar = useSelector(cssVariables);
	const [cssVarLoaded, setCssVarLoaded] = React.useState(false);
	const editorRef = React.useRef(null);
	const [isDragging, setIsDragging] = React.useState(false);
	const [offset, setOffset] = React.useState({ x: 0, y: 0 });

	function handleMouseDown(e) {
		// let mouseX = e.pageX;
		// let mouseY = e.pageY;
		// let x = editorRef.current.getBoundingClientRect().left
		// let y = editorRef.current.getBoundingClientRect().top
		// setOffset({
		//     x:mouseX-x,
		//     y:mouseY-y
		// })
		// setIsDragging(true)
	}

	function handleMouseMove(e) {
		// e.stopPropagation();
		// e.preventDefault()
		// if(!isDragging) return
		// let mouseX = e.pageX;
		// let mouseY = e.pageY;
		// console.log( mouseY-offset.y)
		// console.log(mouseX-offset.x)
		// editorRef.current.style.top = mouseY-offset.y+'px';
		// editorRef.current.style.left = mouseX-offset.x+'px';
		// editorRef.current.style.position = 'absolute'
	}

	React.useEffect(() => {
		if (cssVarLoaded && cssVar) {
			updateViewCssVariables({
				variables: {
					viewId: String(viewId),
					cssVariables: JSON.stringify(cssVar),
				},
			});
		} else {
			setCssVarLoaded(cssVar ? true : false);
		}
	}, [cssVar]);

	return (
		<Popover zIndex={9999} placement="right-end" w={'auto'} ml={'70px'}>
			<PopoverTrigger>
				<IconButton
					disabled={cssVar ? false : true}
					bg={'white'}
					_hover={y300}
					_active={y400}
					_focus={y400}
					variant="outline"
					aria-label="Editor de Tokens"
					icon={<UilPalette size={24} />}
				/>
			</PopoverTrigger>
			<Portal>
				<PopoverContent w={boxW}>
					<Box ref={editorRef} {...boxPopoverWrapper}>
						<PopoverHeader
							onMouseDown={handleMouseDown}
							onMouseUp={(e) => setIsDragging(false)}
							onMouseMove={handleMouseMove}
							_hover={{ cursor: 'grab' }}
							bg={'gray.100'}
							borderRadius={'6px 6px 0 0'}
						>
							<Flex userSelect={'none'} _hover={{ cursor: 'grab' }} position="relative">
								<FormLabel
									_hover={{ cursor: 'grab' }}
									m={0}
									borderColor={'gray.200'}
									fontFamily={'Poppins'}
									color={'gray.700'}
									fontWeight="bold"
								>
									Editor de Tokens
								</FormLabel>
								<PopoverCloseButton top={0} right={0} />
							</Flex>
						</PopoverHeader>
						<CSSEditorInputs />
					</Box>
				</PopoverContent>
			</Portal>
		</Popover>
	);
};

export default PopoverEditCSSVariables;
